<template>
 <div class="app-inner">
   <div class="changeTable">
     <el-badge :value="schedule || ''" class="item">
       <div class="switch" :class="type === 'inset'?'switch1':'switch2'" @click="changeDiv('inset')">待办消息</div>
     </el-badge>
     <el-badge :value="approvalTotalCount || ''" class="item">
       <div class="switch" :class="type === 'approval'?'switch1':'switch2'" @click="changeDiv('approval')" style="margin-left: 20px">待审核</div>
     </el-badge>
     <el-badge :value=" contract || ''" class="item" style="margin-left: .3rem">
       <div class="switch" :class="type === 'maturity'?'switch1':'switch2'" @click="changeDiv('maturity')" style="margin-left: 20px">合同到期提醒</div>
     </el-badge>
     <el-badge :value="rentTotalCount || ''" class="item" style="margin-left: .3rem" v-if="showRent">
       <div class="switch" :class="type === 'rent'?'switch1':'switch2'" @click="changeDiv('rent')" style="margin-left: 20px">交租提醒</div>
     </el-badge>
     <el-badge :value="leaseTotalCount || ''" class="item" style="margin-left: .3rem" v-if="showLease">
       <div class="switch" :class="type === 'lease'?'switch1':'switch2'" @click="changeDiv('lease')" style="margin-left: 20px">到期提醒</div>
     </el-badge>
     <el-badge :value="intentionTotalCount || ''" class="item" style="margin-left: .3rem" v-if="showIntention">
       <div class="switch" :class="type === 'intention'?'switch1':'switch2'" @click="changeDiv('intention')" style="margin-left: 20px">意向留言代办</div>
     </el-badge>
   </div>
   <div class="table" v-if="type === 'inset'">
     <!--      列表-->
     <div class="searchList">
       <el-table
           v-loading="loading"
           :data="tableData"
           :default-sort = "{prop: 'id', order: 'descending'}"
           style="width: 100%"
           :highlight-current-row="false"
           :header-cell-style="{background:'#F4F7FA',color:'#606266'}">
         <el-table-column
             label="序号"
             type="index"
             :index="typeIndex"
             width="100">
         </el-table-column>
           <template v-for="(item, index) in tableColumnsSchedule">
             <el-table-column
                 :key="index"
                 :prop="item.prop"
                 :label="item.label"
                 :width="item.width">
             </el-table-column>
           </template>
         <el-table-column label="操作" width="160">
           <template slot-scope="scope" class="tableButton">
             <el-button class="tableBtn" @click="viewOrHandle(scope.row)" type="text" size="small">详情</el-button>
           </template>
         </el-table-column>
       </el-table>
     </div>
     <el-pagination
         @current-change="handleCurrentChange"
         :current-page.sync="currentPage"
         :page-size="pageSize"
         layout="total, prev, pager, next, jumper"
         :total="totalCount"
         class="paginationBody">
     </el-pagination>
   </div>
   <div class="table" v-if="type ==='approval'">
    <Approval
      :page="approvalPageNum"
      :tableData="approvalTableData"
      :totalCount="approvalTotalCount"
      @pageChange="pageChange"
      type="approval"
    >
    </Approval>
   </div>
   <div class="table" v-else-if="type === 'maturity'">
     <!--      列表-->
     <div class="searchList">
       <el-table
           v-loading="loading"
           :data="tableDataContract"
           :default-sort = "{prop: 'id', order: 'descending'}"
           style="width: 100%"
           :highlight-current-row="false"
           :header-cell-style="{background:'#F4F7FA',color:'#606266'}">
         <el-table-column
             label="序号"
             type="index"
             :index="typeIndexContract"
             width="100">
         </el-table-column>
         <template v-for="(item, index) in tableColumnsContract">
           <el-table-column
               :key="index"
               :prop="item.prop"
               :label="item.label"
               :width="item.width">
           </el-table-column>
         </template>
         <el-table-column label="操作" width="160" v-if="roleName!== '管理员'">
           <template slot-scope="scope" class="tableButton">
             <el-button v-if="scope.row.operationStatus === 0" class="tableBtn" @click="viewOrRemind(scope.row)" type="text" size="small">未读</el-button>
             <el-button v-else class="tableBtn" type="text" size="small" style="color: #111111">已知晓</el-button>
           </template>
         </el-table-column>
       </el-table>
     </div>
     <el-pagination
         @current-change="handleCurrentChangeContract"
         :current-page.sync="currentPage1"
         :page-size="pageSize1"
         layout="total, prev, pager, next, jumper"
         :total="totalCount1"
         class="paginationBody">
     </el-pagination>
   </div>
   <div class="table" v-else-if="type ==='rent'">
    <house
    :page="rentPageNum"
    :tableData="rentTableData"
    :totalCount="rentTotalCount"
    @pageChange="pageChange"
    type="rent"/>
   </div>
   <div class="table" v-else-if="type === 'lease'">
    <house
    :page="leasePageNum"
    :tableData="leaseTableData"
    :totalCount="leaseTotalCount"
    @pageChange="pageChange"
    type="lease"/>
   </div>
   <div class="table" v-else-if="type === 'intention'">
    <table-list
      :loading="intentionLoading"
      :data="intentionTableData"
      :page="intentionPage"
      :page-size="intentionPageSize"
      :total="intentionTotalCount"
      :columnDefs="columnDefs"
      @pageChange="intentionPageChange"
      >
        <template #operate={row}>
          <el-button type="text" size="small" @click="goIntentionDetail">查看详情</el-button>
        </template>
      </table-list>
   </div>
   <div class="dialogDiv">
     <!--      合同到期提醒弹出框-->
     <el-dialog title="合同到期提醒" :visible.sync="remindDialogVisible" :modal-append-to-body='false' center>
       <span>合同编号： <label style="color: #1989fa">{{remindNumber}}</label> 临近到期！</span>
       <span slot="footer" class="dialog-footer">
          <el-button class="searchBtn" @click="remindDialogVisible = false">取 消</el-button>
          <el-button class="searchBtn" type="primary" @click="remindFun()">确 定</el-button>
        </span>
     </el-dialog>
   </div>
 </div>
</template>

<script>
import { todoList, noticeList, readOperate } from '@/api/homePage'
import base from '@/utils/index'
import { baseRoomInfo } from '@/api/basicInfo'
import { compTotalApply, compIntentionFeedbackInfo } from '@/api/comprehensive'
import { query } from '@/api/baseFlowConfig'
import moment from 'moment'
import House from './house.vue'
import Approval from './approval.vue'
import TableList from '@/components/TableList.vue'
export default {
  name: 'index',
  components: {
    House,
    Approval,
    TableList
  },
  data () {
    return {
      type: 'inset',
      loading: false,
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      currentPage1: 1,
      totalCount1: 0,
      pageSize1: 10,
      showScheduleTable: true,
      contractId: '123456',
      remindDialogVisible: false,
      changeChart: true,
      schedule: '',
      contract: '',
      // 合同到期提醒的 是否知晓 参数
      remindNumber: '',
      remindId: '',
      tableColumnsSchedule: [
        {
          prop: 'type',
          label: '类型'
        },
        {
          prop: 'classify',
          label: '分类'
        },
        {
          prop: 'contractTitle',
          label: '标题',
          width: 300
        },
        {
          prop: 'createTime',
          label: '时间'
        }
      ],
      tableColumnsContract: [
        {
          prop: 'type',
          label: '类型'
        },
        {
          prop: 'classify',
          label: '分类'
        },
        {
          prop: 'contractTitle',
          label: '标题',
          width: 300
        },
        {
          prop: 'createTime',
          label: '时间'
        }
      ],
      tableData: [],
      tableDataContract: [],
      // 房租及到到期相关
      rentPageNum: 1,
      // pageSize: 10, // 分页貌似都是10
      rentTableData: [],
      rentTotalCount: 0,
      leasePageNum: 1,
      leaseTableData: [],
      leaseTotalCount: 0,
      approvalPageNum: 1,
      approvalTableData: [],
      approvalTotalCount: 0,
      showRent: false, // 交租提醒权限
      showLease: false, // 到期提醒权限
      showIntention: false, // 意向留言代办权限
      intentionPageSize: 10,
      intentionPage: 1,
      intentionTotalCount: 0,
      intentionTableData: [],
      columnDefs: [
        { label: '姓名', prop: 'name' },
        { label: '联系电话', prop: 'mobile' },
        { label: '意向园区', prop: 'parkName' },
        { label: '备注', prop: 'remark' },
        { label: '留言时间', prop: 'createTime' },
        { label: '操作', prop: 'operate', width: 240 }
      ],
      intentionLoading: false
    }
  },
  mounted () {
    const baseFunc = base()
    this.roleName = baseFunc.getLocalStorage('userInfo_roleName')
    this.getData()
    this.getDataContract()
    this.getAuth(baseFunc.getLocalStorage('userInfo'))
    this.getApprovalList()
    // this.intentionPageChange()
  },
  methods: {
    // 获取流程配置权限
    getAuth(userInfo) {
      query({
        pageSize: 10,
        pageNum: 1
      }).then(res => {
        const { result = {} } = res
        let userName = JSON.parse(userInfo || '{}').userName
        let rentList = result.records.find((item) => item.flowName === '房屋租金未交提醒')
        let rent = rentList.reviewerList.split(',').find(item => item === userName)
        if (rent) {
          this.showRent = true
          this.queryRentList('rent')
        }
        let leaseList = result.records.find((item) => item.flowName === '房屋租赁到期提醒')
        let lease = leaseList.reviewerList.split(',').find(item => item === userName)
        if (lease) {
          this.showLease = true 
          this.queryRentList('lease')
        }

        let intentionList = result.records.find((item) => item.flowName === '意向留言反馈提醒')
        let intention = intentionList.reviewerList.split(',').find(item => item === userName)
        if (intention) {
          this.showIntention = true 
          this.getIntentionData()
        }
      })
    },
    // 处理表格序号，序号递增
    typeIndex (index) {
      let vm = this // 处理分页数据的 index
      return (vm.currentPage - 1) * vm.pageSize + index + 1
    },
    typeIndexContract (index) {
      let vm = this // 处理分页数据的 index
      return (vm.currentPage1 - 1) * vm.pageSize1 + index + 1
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryList()
    },
    handleCurrentChangeContract (val) {
      this.currentPage1 = val
      this.queryListContract()
    },
    viewOrHandle (row) {
      this.$router.push({
        path: '/overview/approvalOpinion',
        query: {
          id: row.id,
          contractNumber: row.contractNumber
        }
      })
    },
    changeDiv (num) {
      // this.showScheduleTable = true
      // if (num === 1) {
      //   // this.showScheduleTable = true
      //   // this.changeChart = true
      //   this.type = 'inset'
      // } else if (num === 2) {
      //   this.type = 'maturity'
      //   // this.showScheduleTable = false
      //   // this.changeChart = false
      // } else {
      this.type = num
      if (num === 'rent' || num === 'lease') {
        this.queryRentList(num)
      }
      if (num === 'approval') {
        this.getApprovalList()
      }
      // }
    },
    viewOrRemind (row) {
      this.remindNumber = row.contractNumber
      this.remindId = row.id
      this.remindDialogVisible = true
    },
    // 已知晓
    async remindFun () {
      let res = await readOperate({
        id: this.remindId
      })
      if (res.code === 0) {
        this.$message.success('已知晓')
        this.remindDialogVisible = false
        this.getDataContract()
      } else {
        this.$message.error(res.message)
      }
    },
    // 查询 待办消息
    getData () {
      this.currentPage = 1
      this.queryList()
    },
    // 查询 合同到期提醒
    getDataContract () {
      this.currentPage1 = 1
      this.queryListContract()
    },
    // 待办消息
    async queryList () {
      let res = await todoList({
        pageNum: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === 0) {
        this.tableData = []
        this.schedule = res.result.total
        res.result.records.forEach(item => {
          this.tableData.push({
            contractTitle: '合同编号:' + item.contractNumber + ' 待审批',
            type: '待办消息',
            classify: '合同审批',
            createTime: item.latestedProcessTime,
            contractNumber: item.contractNumber,
            id: item.id
          })
        })
        this.totalCount = res.result.total
      }
    },
    // 合同到期提醒
    async queryListContract () {
      let res = await noticeList({
        pageNum: this.currentPage1,
        pageSize: this.pageSize1
      })
      if (res.code === 0) {
        this.tableDataContract = []
        if (this.roleName === '管理员') {
          this.contract = res.result.total
        } else {
          this.contract = res.result.unreadCount
        }
        res.result.records.forEach(item => {
          this.tableDataContract.push({
            contractTitle: '合同编号:' + item.contractNumber + ' 临近到期',
            type: '合同到期提醒',
            classify: '消息',
            createTime: item.expireDate,
            operationStatus: item.operationStatus,
            contractNumber: item.contractNumber,
            id: item.id
          })
        })
        this.totalCount1 = res.result.total
      }
    },
    queryRentList (type = 'rent') {
      let json = {
        pageNum: this[`${type}PageNum`],
        pageSize: 10,
        rentType: '已出租',
        hasPayed: type === 'rent' ? 0 : '',
        rentEndDate: type === 'rent' ? '' : moment().add(6, 'months').format("YYYY-MM-DD"),
      }
      baseRoomInfo(type === 'rent' ? 'query' : 'listUpTime', {
        ...json
        }).then(res => {
          const { code, result } = res
          if (code !== 0) return
          this[`${type}TableData`] = result.records
          this[`${type}TotalCount`] = result.total
       })
    },
    getApprovalList(type = 'approval') {
      compTotalApply('forPcIndex/listAllApplyWaitForMe', {
        pageSize: 10, 
        pageNum: this[`${type}PageNum`],
      }).then(res => {
        const { code, result } = res
        if (code !== 0) return
        this[`${type}TableData`] = result.records
        this[`${type}TotalCount`] = result.total
      })
    },
    pageChange (page, type) {
      if (type === 'rent' || type === 'lease') {
        this[`${type}PageNum`] = page
        this.queryRentList(type)
      } else {
        this[`${type}PageNum`] = page
        this.getApprovalList(type)
      }
    },
    // 意向留言代办
    getIntentionData() {
      this.intentionLoading = true
      compIntentionFeedbackInfo('pageListIntentionFeedback', {
        pageSize: this.intentionPageSize,
        handleStatus: 0,
        pageNum: this.intentionPage,
      }).then(res => {
        const { code, result } = res
        this.intentionLoading = false
        if (code !== 0) return
        this.intentionTableData = result.records
        this.intentionTotalCount = result.total
      })
    },
    intentionPageChange(page) {
      this.intentionPage = page
      this.getIntentionData()
    },
    goIntentionDetail() {
      this.$router.push({
        path: '/comprehensive/intentionLeave',
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .app-inner {
    width: 98%;
    height: 70vh;
    padding: 0.2rem;
    box-sizing: border-box;
  }
    .changeTable{
      margin-left: .5rem;
      margin-top: -.1rem;
      .switch{
        width: 1.1rem;
        text-align: center;
        float: left;
        display: inline;
        padding-top: .07rem;
        padding-bottom: .07rem;
        border:1px solid #3498db;
        border-radius: .07rem;
      }
      .switch1 {
        color: rgba(255, 255, 255, 1);
        background-color: #3498db;
        cursor: pointer;
      }
      .switch2 {
        color: #3498db;
        cursor: pointer;
      }
    }
    .table{
      margin-top: .3rem;
      margin-left: .5rem;
      text-align: center;
      width: 14.8rem;
      .searchList{
      }
      .paginationBody{
        margin-top: .1rem;
      }
    }
</style>
